import React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import {
  MdArrowDownward,
  MdArrowUpward,
  MdAssignment,
  MdDashboard,
  MdFileDownload,
  MdLibraryBooks,
  MdMonetizationOn,
  MdPeople,
  MdPeopleOutline,
} from "react-icons/md";
import { Link } from "react-router-dom";
import { ROUTES } from "../../utils/RouteConstants";
import { ROLES } from "../../api/Constants";
import {
  MenuWidth,
  IconWrapper,
  StyledHr,
  MenuItemContent,
  MenuText,
} from "./MenuStyles";

export default ({ user, toggleDrawer, side }) => {
  const linkStyle = {
    textDecoration: "none",
    color: "inherit",
    width: "inherit",
  };
  return (
    <MenuWidth
      role="presentation"
      onClick={toggleDrawer(side, false)}
      onKeyDown={toggleDrawer(side, false)}
    >
      <List>
        <ListItem>
          <Link to={ROUTES.DASHBOARD} style={linkStyle}>
            <MenuItemContent>
              <IconWrapper>
                <MdDashboard />
              </IconWrapper>
              <MenuText>Dashboard</MenuText>
            </MenuItemContent>
          </Link>
        </ListItem>

        <ListItem>
          <Link to={ROUTES.MEMBERS} style={linkStyle}>
            <MenuItemContent>
              <IconWrapper>
                <MdPeople />
              </IconWrapper>
              <MenuText>Members</MenuText>
            </MenuItemContent>
          </Link>
        </ListItem>

        <ListItem>
          <Link to={ROUTES.DEPENDANTS} style={linkStyle}>
            <MenuItemContent>
              <IconWrapper>
                <MdPeopleOutline />
              </IconWrapper>
              <MenuText>Dependants</MenuText>
            </MenuItemContent>
          </Link>
        </ListItem>

        <StyledHr />

        {user != null && user.role.id <= ROLES.ADMIN && (
          <>
            <ListItem>
              <Link to={ROUTES.PREMIUMS_FORM} style={linkStyle}>
                <MenuItemContent>
                  <IconWrapper>
                    <MdArrowUpward />
                  </IconWrapper>
                  <MenuText>Premiums</MenuText>
                </MenuItemContent>
              </Link>
            </ListItem>

            <ListItem>
              <Link to={ROUTES.CLAIMS_FORM} style={linkStyle}>
                <MenuItemContent>
                  <IconWrapper>
                    <MdArrowDownward />
                  </IconWrapper>
                  <MenuText>Claims</MenuText>
                </MenuItemContent>
              </Link>
            </ListItem>

            <ListItem>
              <Link to={ROUTES.EXPENSE_FORM} style={linkStyle}>
                <MenuItemContent>
                  <IconWrapper>
                    <MdMonetizationOn />
                  </IconWrapper>
                  <MenuText>Expenses</MenuText>
                </MenuItemContent>
              </Link>
            </ListItem>

            <ListItem>
              <Link to={ROUTES.INCOME_FORM} style={linkStyle}>
                <MenuItemContent>
                  <IconWrapper>
                    <MdMonetizationOn />
                  </IconWrapper>
                  <MenuText>Incomes</MenuText>
                </MenuItemContent>
              </Link>
            </ListItem>

            <ListItem>
              <Link to={ROUTES.INVESTMENTS_FORM} style={linkStyle}>
                <MenuItemContent>
                  <IconWrapper>
                    <MdMonetizationOn />
                  </IconWrapper>
                  <MenuText>Investments</MenuText>
                </MenuItemContent>
              </Link>
            </ListItem>

            <ListItem>
              <Link to={ROUTES.CASH_AT_HAND_FORM} style={linkStyle}>
                <MenuItemContent>
                  <IconWrapper>
                    <MdMonetizationOn />
                  </IconWrapper>
                  <MenuText>Cash At Hand</MenuText>
                </MenuItemContent>
              </Link>
            </ListItem>

            <StyledHr />

            <ListItem>
              <Link to={ROUTES.STATEMENT_SCREEN} style={linkStyle}>
                <MenuItemContent>
                  <IconWrapper>
                    <MdLibraryBooks />
                  </IconWrapper>
                  <MenuText>Statements</MenuText>
                </MenuItemContent>
              </Link>
            </ListItem>
          </>
        )}

        <ListItem>
          <Link to={ROUTES.QUERY_TRANSACTIONS} style={linkStyle}>
            <MenuItemContent>
              <IconWrapper>
                <MdAssignment />
              </IconWrapper>
              <MenuText>Transactions</MenuText>
            </MenuItemContent>
          </Link>
        </ListItem>

        <ListItem>
          <Link to={ROUTES.REPORTS} style={linkStyle}>
            <MenuItemContent>
              <IconWrapper>
                <MdFileDownload />
              </IconWrapper>
              <MenuText>Reports</MenuText>
            </MenuItemContent>
          </Link>
        </ListItem>
      </List>
    </MenuWidth>
  );
};
